import React, { useState, useEffect, useMemo } from "react";
import {
  Input,
  Card,
  CardBody,
  Media,
  Spinner,
  Collapse,
  Popover,
  PopoverHeader,
  PopoverBody,
} from "reactstrap";

import "./QuickRepliesContent.scss";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

// actions
import { getPredefinedMessagesConversation } from "../../../../../store/predefinedmessages/actions";
import { useCallback } from "react";

const QuickRepliesContent = ({ skillId, onClick, t }) => {
  const dispatch = useDispatch();
  const { global, loadingPredefinedMessage, loadingPredefinedMessageGlobal } =
    useSelector((state) => state.PredefinedMessage);
  const [popovers, setPopovers] = useState({});

  const msgSkill = useSelector(
    (state) => state.PredefinedMessage.skills?.[skillId]
  );

  const mainTheme = useSelector((state) => state.Layout.mainTheme);
  const loading = loadingPredefinedMessage || loadingPredefinedMessageGlobal;

  const [filter, setFilter] = useState("");
  const [collapse, setCollapse] = useState([]);

  const toggle = (key) => {
    let aux = [...collapse];
    aux[key] = !aux[key];
    setCollapse(aux);
  };

  const dataMessages = useMemo(() => {
    if (!global?.length && !msgSkill?.length) return [];

    if (global?.length && !msgSkill?.length) return global;

    if (!global?.length && msgSkill?.length) return msgSkill;

    return global.concat(msgSkill);
  }, [msgSkill, global]);

  const msgs = useMemo(() => {
    if (!dataMessages) return [];

    if (!filter) return dataMessages;

    const res = new RegExp(
      filter.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"),
      "gi"
    );
    return dataMessages.filter((msgFilter) => {
      if (
        msgFilter?.categories?.length &&
        msgFilter.categories.some((category) => category.match(res))
      ) {
        msgFilter.parent = filter;
        return msgFilter;
      }

      // Check if category is null, so predefined is general or geral according to a regex.
      if (
        msgFilter?.categories === null &&
        ("GENERAL".includes(filter.toUpperCase()) ||
          "GERAL".includes(filter.toUpperCase()))
      ) {
        return msgFilter;
      }

      // Check if message text match input from search input
      return msgFilter.text.match(res) || msgFilter.title.match(res);
    });
  }, [filter, dataMessages]);

  const categories = useMemo(() => {
    const categories = [
      {
        name: t("General"),
        messages: [],
        title: [],
        files: [],
      },
    ];
    msgs?.forEach((element) => {
      if (!element?.categories?.length) {
        const pos = categories.findIndex((e) => e.name === t("General"));
        if (pos > -1) {
          categories[pos].messages.push(element.text);
          categories[pos].title.push(element.title);
          categories[pos].files.push(element.files);
        }
      }
      element?.categories?.forEach((category) => {
        const pos = categories.findIndex((e) => e.name === category);
        if (pos > -1) {
          categories[pos].messages.push(element.text);
          categories[pos].title.push(element.title);
          categories[pos].files.push(element.files);
        } else {
          categories.push({
            name: category,
            messages: [element.text],
            title: [element.title],
            files: [element?.files],
          });
        }
      });
    });

    return categories;
  }, [msgs, t]);

  const togglePopover = (id) => {
    id = id.toString();
    setPopovers((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const renderPredefinedMessages = useCallback(() => {
    if (!msgs?.length)
      return (
        <div className="text-center mb-3">{t("No matching records found")}</div>
      );

    return categories?.map((category, key) =>
      msgs[key]?.parent === undefined ? (
        <div key={key} className={`item ${collapse[key] && "item-opened"}`}>
          <div
            className="text-wrap pointer d-flex py-3"
            onClick={() => {
              toggle(key);
            }}
          >
            <i className="bx bx bxs-chevron-right color2 font-size-15 list-icon"></i>
            <div className="d-flex flex-column w-100 ml-2 pl-1">
              <div className="d-flex justify-content-between my-auto">
                <div className="d-inline-flex order-1 title">
                  {category.name}
                </div>
              </div>
            </div>
          </div>

          <Collapse className="mx-1 my-0 " isOpen={collapse[key]}>
            {category.messages.map((message, subkey) => (
              <Card
                className="mt-2 pointer"
                key={`${subkey}${key}`}
                style={{
                  background: mainTheme === "dark" ? "#262B3C" : "#F1F0F0",
                }}
              >
                <CardBody
                  onClick={() =>
                    onClick({ message: message, file: category?.files[subkey] })
                  }
                  className="p-0 d-flex align-items-center "
                  onMouseEnter={() => togglePopover(`${subkey}${key}`)}
                  onMouseLeave={() => togglePopover(`${subkey}${key}`)}
                >
                  <Media body className="p-3" id={`msgBodyFaqs${subkey}${key}`}>
                    <div className="text-muted font-weight-bold max-lines-quick text-truncate">
                      {category.title[subkey]}
                    </div>
                    <p className="mb-0 max-lines-quick text-truncate font-color-predefined-msgsfont-weight-light">
                      {message}
                    </p>
                  </Media>
                  {category?.files[subkey] && (
                    <div
                      className={`file-icon ${mainTheme}`}
                      onClick={() => {
                        window.open(category.files[subkey]);
                      }}
                    >
                      <i className="bx bx-file-blank" />
                    </div>
                  )}
                  <PopoverContainer
                    id={`${subkey}${key}`}
                    message={message}
                    title={category.title[subkey]}
                    isOpen={popovers}
                  />
                </CardBody>
              </Card>
            ))}
          </Collapse>
        </div>
      ) : (
        category.name
          .toUpperCase()
          .includes(msgs[key].parent.toUpperCase()) && (
          <div key={key} className={`item ${collapse[key] && "item-opened"}`}>
            <div
              className="text-wrap pointer d-flex py-3"
              onClick={() => {
                toggle(key);
              }}
            >
              <i className="bx bx bxs-chevron-right color2 font-size-15 list-icon"></i>
              <div className="d-flex flex-column w-100 ml-2 pl-1">
                <div className="d-flex justify-content-between my-auto">
                  <div className="d-inline-flex order-1 title">
                    {category.name}
                  </div>
                </div>
              </div>
            </div>

            <Collapse className="mx-1 my-0 " isOpen={collapse[key]}>
              {category.messages.map((message, subkey) => (
                <Card
                  className="mt-2 pointer"
                  key={`${subkey}${key}`}
                  style={{
                    background: mainTheme === "dark" ? "#262B3C" : "#F1F0F0",
                  }}
                >
                  <CardBody
                    onClick={() =>
                      onClick({
                        message: message,
                        file: category?.files[subkey],
                      })
                    }
                    onMouseEnter={() => togglePopover(`${subkey}${key}`)}
                    onMouseLeave={() => togglePopover(`${subkey}${key}`)}
                    className="p-0 "
                  >
                    <Media
                      body
                      className="p-3"
                      id={`msgBodyFaqs${subkey}${key}`}
                    >
                      <div className="text-muted font-weight-bold">
                        {category.title[subkey]}
                      </div>
                      <p className="mb-0 text-truncate font-color-predefined-msgsfont-weight-light">
                        {message}
                      </p>
                    </Media>
                    <PopoverContainer
                      id={`${subkey}${key}`}
                      message={message}
                      title={category.title[subkey]}
                      isOpen={popovers}
                    />
                  </CardBody>
                </Card>
              ))}
            </Collapse>
          </div>
        )
      )
    );
  }, [msgs, collapse, popovers, mainTheme, categories, onClick, toggle]);

  useEffect(() => {
    if (msgSkill || loadingPredefinedMessage) return;
    skillId && dispatch(getPredefinedMessagesConversation(skillId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skillId, loadingPredefinedMessage, dispatch]);

  useEffect(() => {
    if (loadingPredefinedMessageGlobal || global) return;
    dispatch(getPredefinedMessagesConversation());
  }, [loadingPredefinedMessageGlobal, global, dispatch]);

  return (
    <div className="client-info-card">
      <div className="search-box chat-search-box mb-4">
        <Input
          id="search"
          type="text"
          className="form-control SearchPreDefinedMsgs"
          placeholder={t("Search")}
          autoComplete="off"
          onInput={(e) => {
            setFilter(e.target.value);
          }}
        />
        <i className="bx bx-search-alt search-icon"></i>
      </div>
      {loading && (
        <div className="h-100 text-center pt-4">
          <Spinner animation="border" size="sm" className="spinner" />
        </div>
      )}
      {skillId && !loading && renderPredefinedMessages()}
    </div>
  );
};
export default withTranslation()(QuickRepliesContent);

const PopoverContainer = ({ id, title, message, isOpen }) => {
  return (
    <Popover
      target={`msgBodyFaqs${id}`}
      isOpen={isOpen?.[id?.toString()]}
      placement="bottom"
    >
      {title && <PopoverHeader>{title}</PopoverHeader>}
      <PopoverBody className={`d-inline-block skills-tooltip`}>
        <div className="font-color-predefined-msgs">{message}</div>
      </PopoverBody>
    </Popover>
  );
};
